'use strict';

const CollectionView = require('./collection');

const SeatingSectionView = require('./seatingSection');

class SeatingSectionsListView extends CollectionView {
  tagName() {
    return 'ul';
  }

  className() {
    return 'seating-sections-list';
  }

  initialize() {
    this.module = 'glive_booking_redesign';
    this.childView = SeatingSectionView;
  }

  attributes() {
    return { 'data-bhw': 'SectionsList' };
  }

  constructor() {
    super(...arguments);
    this.on('select', this.select, this);
  }

  select(section) {
    this.options.selection = section;
    this.render();
  }
}

module.exports = SeatingSectionsListView;
